import { render, staticRenderFns } from "./TableOrder.vue?vue&type=template&id=6236f5ff&"
import script from "./TableOrder.vue?vue&type=script&lang=js&"
export * from "./TableOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports